import { Instance, types } from "mobx-state-tree";

export const PageStore = types
  .model('PageStore', {
    // Current page number
    number: types.number,

    // Number of items per page
    size: types.number,

    // Total page count
    count: types.number,

    // Total items count
    total_items: types.number
  })
  .actions((self) => ({}));

export interface IPageStore extends Instance<typeof PageStore> { }
